import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <div className="bg-primary vh-100 p-3">
      <div className="bg-white rounded-4 h-100">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
